import IconButton from "components/atoms/button/IconButton";
import PrimaryDatePicker from "components/molecules/datepicker/PrimaryDatePicker";
import { Controller, useForm } from "react-hook-form";
import Creatable from "react-select/creatable";
import { customStyles } from "lib/helpers/configs/customStyles";
import React, { Dispatch, useEffect, useState } from "react";
import Label from "components/atoms/input/input-label/InputLabel";
import LoadingScreen from "components/atoms/loading-screen/LoadingScreen";
import { useTranslation } from "react-i18next";

export interface IFilterProps {
  status?: string;
  created_at?: any;
  deadline?: any;
}

const initialState: IFilterProps = {
  status: "",
  created_at: undefined,
  deadline: undefined
};

export interface IFilterTableDropdownProps {
  setFilterData?: (args: any) => void;
  FilterData?: IFilterProps;
  setIsOpen?: Dispatch<React.SetStateAction<boolean>>;
}

const CustomerFilterTable: React.FC<IFilterTableDropdownProps> = ({
  setFilterData,
  FilterData,
  setIsOpen
}) => {
  const [DateOfCreation, setDateOfCreation] = useState<Date | null>(
    FilterData?.created_at ? FilterData.created_at : null
  );
  const [Deadline, setDeadline] = useState<Date | null>(
    FilterData?.deadline ? FilterData.deadline : null
  );
  

  const {t} = useTranslation();

  const { control, reset } = useForm({
    defaultValues: {
      status: FilterData?.status || "",
      created_at: FilterData?.created_at || "",
      deadline: FilterData?.deadline || ""
    }
  });

  const [InsideData, setInsideData] = useState<IFilterProps>(
    FilterData || initialState
  );

  useEffect(() => {
    setInsideData((prevFormData: any) => ({
      ...prevFormData,
      created_at: DateOfCreation,
      deadline: Deadline
    }));
  }, [DateOfCreation, Deadline]);
  const handleButtonClick = () => {
    setIsLoading(true);
    if (setFilterData) {
      setFilterData(InsideData);
    }
    setIsOpen && setIsOpen(false);
    setIsLoading(false);
  };
  const ResetData = () => {
    setInsideData(initialState);
    setDateOfCreation(null);
    setDeadline(null);
    reset(initialState);
  };

  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="p-4">
        <LoadingScreen />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <div>
        <Label text={t("Status")} />
        <Controller
          name="status"
          control={control}
          render={({ field }) => (
            <Creatable<any, false>
              {...field}
              placeholder={t("Choose Status")}
              options={[
                { label: `${t("Pending Sales")}`, value: "Pending Sales" },
                { label: `${t("Pending Backoffice")}`, value: "Pending Backoffice" },
                { label: `${t("Processing")}`, value: "Processing" },
                { label: `${t("Done")}`, value: "Done" }
              ]}
              value={
                field.value
                  ? {
                      value: field.value,
                      label: t(field.value.charAt(0).toUpperCase() + field.value.slice(1)),}
                      : null
              }
              className="cursor-pointer font-inter-regular react-select-container"
              classNamePrefix="react-select"
              onChange={(selectedOption) => {
                const selectedValue = selectedOption
                  ? selectedOption.value
                  : null;
                field.onChange(selectedValue);
                setInsideData((prevState) => ({
                  ...prevState,
                  status: selectedValue
                }));
              }}
              styles={customStyles}
              isValidNewOption={() => false}
              menuPosition={"fixed"}
              menuPortalTarget={document.body}
            />
          )}
        />
      </div>
      <PrimaryDatePicker
        label={t("Date of creation")}
        setStartDate={(date: Date | null) => setDateOfCreation(date)}
        startDate={DateOfCreation}
        wrapperClassName="!left-[2px]"
      />
      <PrimaryDatePicker
        label={t("Deadline")}
        setStartDate={(date: Date | null) => setDeadline(date)}
        startDate={Deadline}
        wrapperClassName="!left-[2px]"
      />

      <div className="pt-5">
        <div className="flex flex-row justify-end gap-3">
          <IconButton
            secondary={true}
            className="w-[110px]"
            onClick={ResetData}
          >
            {t("Reset")}
          </IconButton>
          <IconButton className="w-[110px]" onClick={handleButtonClick}>
            {t("Confirm")}
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default CustomerFilterTable;